import React, { useState, createContext } from "react";
import { useEffect } from "react";
import { getIntentHistoryList, userLogout } from "../../../apis/Api";
import intenthistoryPage from "../../../constants/contentFile.json";
import { useNavigate } from "react-router";
import RouteConstant from "../../../constants/routesContent.json";
import { useCookies } from 'react-cookie';
import { processStatus } from "../../../utils/service";

export const IntentHistoryContext = createContext({});
export const IntentHistoryContextProvider = ({ children }) => {
  const [intentHistoryList, setintentHistoryList] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const [logoutAlertMessage, setLogoutAlertMessage] = useState("");
  const historyConstants = intenthistoryPage.errorMessages;
  const logoutConstants = intenthistoryPage.logout;
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
  const [apiStatus, setApiStatus] = useState('');

  const logout = async () => {
    try {
      if (!cookies.xAccessToken) {
        removeCookie('xAccessToken', { path: '/' });
        removeCookie('supplierId', { path: '/' });
        removeCookie('intentToken', { path: '/' });
        removeCookie('userId', { path: '/' });
        navigate(RouteConstant.LOGIN);
      } else {
        const logoutData = await userLogout();

        if (logoutData?.data?.statusCode === 200) {
          removeCookie('xAccessToken', { path: '/' });
          removeCookie('supplierId', { path: '/' });
          removeCookie('intentToken', { path: '/' });
          removeCookie('userId', { path: '/' });
          navigate(RouteConstant.LOGIN);
        } else {
          setShowLogoutAlert(true);
          setLogoutAlertMessage(historyConstants.somethingWrong);
        }
      }
    } catch (error) {
       setShowAlert(false);
       if (error?.response?.data?.statusCode === 401) {
        setShowLogoutAlert(true);
        setLogoutAlertMessage(historyConstants.sessionExpired);
      } else {
        setShowLogoutAlert(true);
        setLogoutAlertMessage(historyConstants.somethingWrong);
      }
    }
  };
  const getHistoryList = async () => {
    setApiStatus('fetching');
    try {
      const getintentlist = await getIntentHistoryList();

      if (getintentlist?.data?.statusCode === 200) {
        setintentHistoryList(getintentlist?.data?.intentInfo); 
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 401) {
        setShowAlert(true);
        setAlertMessage(historyConstants.sessionExpired);
      } else {
        setAlertMessage(historyConstants.somethingWrong);
        setShowAlert(true);
      }
    }
    setApiStatus('completed');
  };
  useEffect(() => {
    getHistoryList();
  }, []);
  const providerValue = {
    intentHistoryList,
    showAlert,
    setShowAlert,
    alertMessage,
    logout,
    showLogoutAlert,
    setShowLogoutAlert,
    logoutConstants,
    logoutAlertMessage,
    processStatus,
    apiStatus
  };
  return (
    <IntentHistoryContext.Provider value={providerValue}>
      {children}
    </IntentHistoryContext.Provider>
  );
};
